export default class DtoInstallationCartographyData {
    constructor(obj) {
        this.idStation = obj.idStation
        this.ignMap = obj.ignMap
        this.geologicalMap = obj.geologicalMap
        this.parcel = obj.parcel
        this.section = obj.section
    }
}